import React from 'react';
import { Navigate } from 'react-router';
import Base from '../Base';
import SelectAsync from 'react-select/async';
import DatePicker from 'react-datepicker2';
//https://s-yadav.github.io/react-number-format/docs/numeric_format/
import NumberFormat from 'react-number-format';
import Person from "../Person";

export default class CustomsClearance extends Base {
	constructor(props) {
		super(props);
		this.state = {
			orderingId: this.isNull(props.OrderingId) ? null : props.OrderingId,
			caller: props.Caller,
			controllerName: 'customsclearance',
			refreshCallerAfterSave: this.isNull(props.RefreshCallerAfterSave) ? true : props.RefreshCallerAfterSave,
			id: this.isNull(props.Id) ? this.defaultGuid() : props.Id,
			data: null,
			loading: true,
		};
		this.inputRefs = [];
		this.keyDownFunction = this.keyDownFunction.bind(this);
	}
	resetRefs() {
		this.inputRefs = [];
	}
	handleKeyDown = (rowIndex, colIndex, e) => {
		const row = this.inputRefs[rowIndex];
		const colCount = row.length;
		const rowCount = this.inputRefs.length;

		if (colCount <= colIndex && rowCount <= rowIndex) return;

		if (e.key === "Enter") {
			e.preventDefault();
			if (colIndex + 1 < colCount) {
				//find first next active input
				if (!row[colIndex + 1]) {
					this.handleKeyDown(rowIndex, colIndex + 1, e);
				}
				else {
					row[colIndex + 1]?.focus();
					if (row[colIndex + 1]?.type === "text") row[colIndex + 1]?.select();
				}
			} else if (rowIndex + 1 < rowCount) {
				if (!this.inputRefs[rowIndex + 1][0]) {
					this.handleKeyDown(rowIndex + 1, 1, e);
				}
				else {
					this.inputRefs[rowIndex + 1][0]?.focus();
					if (this.inputRefs[rowIndex + 1][0]?.type === "text") this.inputRefs[rowIndex + 1][0]?.select();
				}
			}
		}

		if (e.key === "ArrowDown") {
			e.preventDefault();
			e.preventDefault();
			if (rowIndex + 1 < rowCount) {
				this.inputRefs[rowIndex + 1][colIndex]?.focus();
				if (this.inputRefs[rowIndex + 1][colIndex]?.type === "text") this.inputRefs[rowIndex + 1][colIndex]?.select();
			}
		}

		if (e.key === "ArrowUp") {
			e.preventDefault();
			if (rowIndex - 1 >= 0) {
				this.inputRefs[rowIndex - 1][colIndex]?.focus();
				if (this.inputRefs[rowIndex - 1][colIndex]?.type === "text") this.inputRefs[rowIndex - 1][colIndex]?.select();
			}
		}
	}
	componentWillUnmount() {
		this.removeKeyDown();
	}
	componentDidMount() {
		this.addKeyDown();

		this.httpPost("api/v1/customsclearance/get", {
			id: this.state.id,
		})
			.then(data => {
				if (data.status === -1) window.location.href = "/login";
				if (data.status === 1) {
					window.organizationId = data.global.company.id;
					this.state.data = data;
					if (!this.isNull(this.state.orderingId) && this.state.data.record.id === this.getDefaultGuid()) {
						this.setOrdering({ value: this.state.orderingId, label: '' });
					}
					this.state.loading = false;
				}
				else {
					//this.showErorrMessage(data.message);
					this.setState({
						data: data,
						loading: false
					});
				}
			});
	}
	save(e) {
		e.preventDefault();
		if (this.isBlank(this.state.data.record.number)) this.state.data.record.number = 0;
		if (this.isBlank(this.state.data.record.totalCost)) this.state.data.record.totalCost = 0;
		if (this.isBlank(this.state.data.record.totalToll)) this.state.data.record.totalToll = 0;
		if (this.isBlank(this.state.data.record.totalTax)) this.state.data.record.totalTax = 0;
		if (this.isBlank(this.state.data.record.totalCustomsCost)) this.state.data.record.totalCustomsCost = 0;

		this.httpPost("api/v1/customsclearance/save", {
			id: this.state.id,
			organizationId: this.state.data.global.company.id,
			number: this.state.data.record.number,
			orderingId: this.state.data.record.orderingId,
			totalCost: this.state.data.record.totalCost,
			totalToll: this.state.data.record.totalToll,
			totalTax: this.state.data.record.totalTax,
			totalCustomsCost: this.state.data.record.totalCustomsCost,
			date: this.convertMomentToDb(this.state.data.record.date),
			clearanceCompanyId: this.state.data.record.clearanceCompanyId,
			enterCustomId: this.state.data.record.enterCustomId,
			calculatorCustomId: this.state.data.record.calculatorCustomId,
			destinationPort: this.state.data.record.destinationPort,
			originPort: this.state.data.record.originPort,
			price: this.state.data.record.price,
			tax: this.state.data.record.tax,
			toll: this.state.data.record.toll,
			description: this.state.data.record.description,
			transportationType: this.state.data.record.transportationType,
			items: this.state.data.record.items,
		})
			.then(data => {
				if (data.status === -1) window.location.href = "/login";
				if (data.status === 1) {
					this.showSuccessMessage("ترخیص با موفقیت ذخیره شد");

					if (this.state.refreshCallerAfterSave)
						this.state.caller.refreshData(null, "list", "json", (this.state.id === this.getDefaultGuid() ? true : false));

					this.closeMe();
				}
				else {
					this.showErorrMessage(data.message);
					this.setState({
						loading: false
					});
				}
			});
	}
	removeRow(id) {
		this.resetRefs();
		var temp = [];
		var index = 1;
		this.state.data.record.items.sort((a, b) => a.index - b.index).forEach(r => {
			if (r.id != id) {
				temp.push(r);
				temp[temp.length - 1].index = index;
				index++;
			}
		});
		this.state.data.record.items = temp;
		this.updateFormula();
	}
	upIndex(id) {
		this.resetRefs();
		var idIndex = -1;
		this.state.data.record.items.forEach((r, index) => {
			if (r.id == id) idIndex = index;
		});
		if (idIndex != -1 && idIndex > 0) {
			var ii = this.state.data.record.items[idIndex].index;
			this.state.data.record.items[idIndex].index = ii - 1;
			this.state.data.record.items[idIndex - 1].index = ii;
			this.setState({ data: this.state.data });
		}
	}
	downIndex(id) {
		this.resetRefs();
		var idIndex = -1;
		this.state.data.record.items.forEach((r, index) => {
			if (r.id == id) idIndex = index;
		});
		if (idIndex != -1 && idIndex < this.state.data.record.items.length - 1) {
			var ii = this.state.data.record.items[idIndex].index;
			this.state.data.record.items[idIndex].index = ii + 1;
			this.state.data.record.items[idIndex + 1].index = ii;
			this.setState({ data: this.state.data });
		}
	}
	async setBodyValuesetBodyValue(id, field, value, rowIndex = 0, columnIndex = 0) {
		for (var i = 0; i < this.state.data.record.items.length; i++) {
			if (this.state.data.record.items[i].id === id) {
				this.state.data.record.items[i][field] = value;
			}
		}
		this.updateFormula();
	}
	updateFormula() {
		var totalTax = 0;
		var totalToll = 0;
		var totalCustomsCost = 0;
		var totalCost = 0;
		this.state.data.record.items.forEach(f => {
			if (f.tax === '') f.tax = 0;
			if (f.toll === '') f.toll = 0;
			if (f.customsCost === '') f.customsCost = 0;

			totalTax += f.tax;
			totalToll += f.toll;
			totalCustomsCost += f.customsCost;
			f.totalCost = f.tax + f.toll + f.customsCost;
			totalCost += f.totalCost;
		});

		this.state.data.record.totalCost = totalCost;
		this.state.data.record.totalToll = totalToll;
		this.state.data.record.totalTax = totalTax;
		this.state.data.record.totalCustomsCost = totalCustomsCost;

		this.setState({ date: this.state.data });
	}
	setClearanceCompany(e) {
		if (e.value == -1) {
			this.state.data.record.clearanceCompanyId = null;
			this.state.data.record.clearanceCompanyName = '';
			this.showComponents({
				component: <Person Caller={this} FromAutoComplete={true} />,
			});
			return;
		}
		this.state.data.record.clearanceCompanyId = e.value;
		this.state.data.record.clearanceCompanyName = e.label;
		this.setState({ data: this.state.data });
	}
	onEditClearanceCompany(id) {
		this.showComponents({ component: <Person Caller={this} Id={id} FromAutoComplete={true} /> });
	}
	setCalculatorCustom(e) {
		if (e.value == -1) {
			this.state.data.record.calculatorCustomId = null;
			this.state.data.record.calculatorCustomName = '';
			this.showComponents({
				component: <Person Caller={this} FromAutoComplete={true} />,
			});
			return;
		}
		this.state.data.record.calculatorCustomId = e.value;
		this.state.data.record.calculatorCustomName = e.label;
		this.setState({ data: this.state.data });
	}
	onEditCalculatorCustom(id) {
		this.showComponents({ component: <Person Caller={this} Id={id} FromAutoComplete={true} /> });
	}
	setEnterCustom(e) {
		if (e.value == -1) {
			this.state.data.record.enterCustomId = null;
			this.state.data.record.enterCustomName = '';
			this.showComponents({
				component: <Person Caller={this} FromAutoComplete={true} />,
			});
			return;
		}
		this.state.data.record.enterCustomId = e.value;
		this.state.data.record.enterCustomName = e.label;
		this.setState({ data: this.state.data });
	}
	onEditEnterCustom(id) {
		this.showComponents({ component: <Person Caller={this} Id={id} FromAutoComplete={true} /> });
	}
	setOrdering(e) {
		if (e === null) {
			this.state.data.record.orderingId = null;
			this.state.data.record.orderingFullNumber = '';
			this.state.data.record.items = [];
			this.updateFormula();
		}
		else {
			this.state.data.record.orderingId = e.value;
			this.state.data.record.orderingFullNumber = e.label;
			this.state.data.record.items = [];

			this.httpPost('api/v1/customsclearance/search/factor', {
				orderingId: this.state.data.record.orderingId,
			}).then((data) => {
				if (data.status === -1) window.location.href = '/login';
				if (data.status === 1) {
					this.state.loading = false;
					this.state.data.record.items = data.records;
					this.updateFormula();
				} else {
					this.showErorrMessage(data.message);
					this.setState({
						loading: false,
					});
				}
			});

		}
		this.setState({ data: this.state.data });
	}
	//override
	remove() {
		var id = this.state.id_to_remove;
		if (this.isNull(id) && !this.isNull(this.state.selectedIds)) id = this.state.selectedIds;

		this.httpPost("api/v1/" + this.state.controllerName + "/remove", {
			id,
			companyId: this.state.data.global.company.id,
			organizationId: this.state.data.global.company.id,
		})
			.then(data => {
				if (data.status === -1) window.location.href = "/login";
				if (data.status === 1) {
					this.showSuccessMessage("اطلاعات با موفقیت حذف گردید");
					this.state.caller.refreshData();
					this.closeMe();
				}
				else {
					this.showErorrMessage(data.message);
					this.setState({ showConfirmRemove: false });
				}
			})
			.catch(err => {
				this.showErorrMessage("پاسخی دریافت نشد.لطفا مجدد تلاش نمایید.");
			});
	}
	renderBody() {
		var trs = [];
		this.state.data.record.items.sort((a, b) => a.index - b.index).forEach((item, index) => {
			var tds = [];
			let refColumnIndex = 0;

			tds.push(<td>
				<span className="inGridRowNumber">{(index + 1)}</span>
				{<div style={{ "font-size": "9pt", "color": "silver" }}>
					{index > 0 && index != this.state.data.record.items.length - 1 && <span onClick={e => this.upIndex(item.id)} className="fa fa-arrow-up move-up" title="انتقال به بالا"></span>}
					{index < this.state.data.record.items.length - 2 && <span onClick={e => this.downIndex(item.id)} className="fa fa-arrow-down move-down" title="انتقال به پایین"></span>}
				</div>}
			</td>);

			tds.push(<td>{item.factorNumber}</td>);
			tds.push(<td>{item.stuffName}</td>);
			tds.push(<td>{item.count}</td>);
			tds.push(<td>{item.unitName}</td>);

			if (this.state.data.global.company.stuffSubUnitEnable === 2) {
				tds.push(<td>{item.modulusCount}</td>);
				tds.push(<td>{item.modulusUnitName}</td>)
			}

			tds.push(<td>{item.total}</td>);

			let _refColumnIndexC1 = refColumnIndex;
			tds.push(<td>
				<span className="onlyMobile">هزینه گمرک: </span>
				<NumberFormat value={item.customsCost} onChange={e => this.setBodyValue(item.id, 'customsCost', parseInt(e.target.value.replace(/,/g, '')))} thousandSeparator={true} prefix={''} className='form-control text-center ltr'
					getInputRef={(el) => {
						if (!this.inputRefs[index]) this.inputRefs[index] = [];
						this.inputRefs[index][_refColumnIndexC1] = el;
					}}
					onKeyDown={(e) => this.handleKeyDown(index, _refColumnIndexC1, e)}
				/></td>);
			refColumnIndex++;

			let _refColumnIndexC2 = refColumnIndex;
			tds.push(<td>
				<span className="onlyMobile">مالیات: </span>
				<NumberFormat value={item.tax} onChange={e => this.setBodyValue(item.id, 'tax', parseInt(e.target.value.replace(/,/g, '')))} thousandSeparator={true} prefix={''} className='form-control text-center ltr'
					getInputRef={(el) => {
						if (!this.inputRefs[index]) this.inputRefs[index] = [];
						this.inputRefs[index][_refColumnIndexC2] = el;
					}}
					onKeyDown={(e) => this.handleKeyDown(index, _refColumnIndexC2, e)}
				/></td>);
			refColumnIndex++;

			let _refColumnIndexC3 = refColumnIndex;
			tds.push(<td>
				<span className="onlyMobile">عوارض: </span>
				<NumberFormat value={item.toll} onChange={e => this.setBodyValue(item.id, 'toll', parseInt(e.target.value.replace(/,/g, '')))} thousandSeparator={true} prefix={''} className='form-control text-center ltr'
					getInputRef={(el) => {
						if (!this.inputRefs[index]) this.inputRefs[index] = [];
						this.inputRefs[index][_refColumnIndexC3] = el;
					}}
					onKeyDown={(e) => this.handleKeyDown(index, _refColumnIndexC3, e)}
				/></td>);
			refColumnIndex++;

			tds.push(<td>
				<span title="حذف سطر" onClick={e => this.removeRow(item.id)} className="fa fa-trash fa-fw close-grid-row"></span>
			</td>);

			trs.push(<tr key={item.id}>
				{tds}
			</tr>);
		});

		return <tbody>{trs}</tbody>
	}
	renderForm() {
		return <div className="modal fade listModal in show" tabIndex="-1" role="dialog">
			<div className="modal-backdrop fade in" style={{ "height": "100%" }} onClick={e => this.closeMe()}></div>
			<div className="modal-dialog ui-draggable" style={{ "width": "96%", "left": "7.125px", "top": "-2px" }}>
				<div className="modal-content">
					<div className="modal-body">
						<div className="modal-header modal-header-info" style={{ "padding": "0" }}>
							<button type="button" className="close" onClick={e => this.closeMe()} aria-label="Close"><span aria-hidden="true">×</span></button>
							<h4 className="modal-title">ترخیص</h4>
						</div>
						<div className="modal-body" style={{ "display": "flex", "flex-direction": "column", "gap": "10px" }}>
							<div className="row">
								{this.isNull(this.state.orderingId) && <div className="col-sm-3">
									<div className="form-group">
										<label for="invoiceContact" className="title1">سفارش<span className="red">*</span></label>
										<SelectAsync
											value={
												!this.isNull(this.state.data.record.orderingId)
													? [
														{
															value: this.state.data.record.orderingId,
															label: this.state.data.record.orderingFullNumber,
														},
													]
													: null
											}
											isMulti={false}
											placeholder="انتخاب سفارش"
											noOptionsMessage={({ inputValue }) =>
												inputValue ? "نتیجه‌ای یافت نشد" : null
											}
											defaultOptions={[]}
											components={{
												DropdownIndicator: () => null,
												IndicatorSeparator: () => null,
											}}
											loadOptions={(inputValue, callback) => this.loadOrderingsOptions(inputValue, callback, 4)}
											onChange={e => this.setOrdering(e)}
										/>
									</div>
								</div>}
								<div className="col-sm-3">
									<div className="form-group">
										<label for="invoiceContact" className="title1">طرف مقابل<span className="red">*</span></label>
										<div id="displayPersonBalance" style={{ "display": "inline-block" }} ></div>
										<em className="icon ni ni-plus hand ms-1" onClick={e => this.setClearanceCompany({ value: -1 })}></em>,
										{!this.isNull(this.state.data.record.clearanceCompanyId) && <em onClick={e => this.onEditClearanceCompany(this.state.data.record.clearanceCompanyId)} className="icon ni ni-pen hand ms-1"></em>}
										<SelectAsync
											value={!this.isNull(this.state.data.record.clearanceCompanyId) ? [{ value: this.state.data.record.clearanceCompanyId, label: this.state.data.record.clearanceCompanyName }] : null}
											isMulti={false}
											placeholder="انتخاب طرف حساب"
											noOptionsMessage={({ inputValue }) =>
												inputValue ? "نتیجه‌ای یافت نشد" : null
											}
											defaultOptions={[]}
											components={{
												DropdownIndicator: () => null,
												IndicatorSeparator: () => null,
											}}
											loadOptions={(inputValue, callback) => this.loadPersonsOptions(inputValue, callback, 1)}
											onChange={e => this.setClearanceCompany(e)}
										/>
									</div>
								</div>
								<div className="col-sm-3">
									<div className="form-group">
										<label for="invoiceContact" className="title1">گمرک ورودی<span className="red">*</span></label>
										<div id="displayPersonBalance" style={{ "display": "inline-block" }} ></div>
										<em className="icon ni ni-plus hand ms-1" onClick={e => this.setEnterCustom({ value: -1 })}></em>,
										{!this.isNull(this.state.data.record.enterCustomId) && <em onClick={e => this.onEditEnterCustom(this.state.data.record.enterCustomId)} className="icon ni ni-pen hand ms-1"></em>}
										<SelectAsync
											value={!this.isNull(this.state.data.record.enterCustomId) ? [{ value: this.state.data.record.enterCustomId, label: this.state.data.record.enterCustomName }] : null}
											isMulti={false}
											placeholder="انتخاب گمرک"
											noOptionsMessage={({ inputValue }) =>
												inputValue ? "نتیجه‌ای یافت نشد" : null
											}
											defaultOptions={[]}
											components={{
												DropdownIndicator: () => null,
												IndicatorSeparator: () => null,
											}}
											loadOptions={(inputValue, callback) => this.loadPersonsOptions(inputValue, callback, 1)}
											onChange={e => this.setEnterCustom(e)}
										/>
									</div>
								</div>
								<div className="col-sm-3">
									<div className="form-group">
										<label for="invoiceContact" className="title1">گمرک محل ارزیابی<span className="red">*</span></label>
										<div id="displayPersonBalance" style={{ "display": "inline-block" }} ></div>
										<em className="icon ni ni-plus hand ms-1" onClick={e => this.setCalculatorCustom({ value: -1 })}></em>,
										{!this.isNull(this.state.data.record.calculatorCustomId) && <em onClick={e => this.onEditCalculatorCustom(this.state.data.record.calculatorCustomId)} className="icon ni ni-pen hand ms-1"></em>}
										<SelectAsync
											value={!this.isNull(this.state.data.record.calculatorCustomId) ? [{ value: this.state.data.record.calculatorCustomId, label: this.state.data.record.calculatorCustomName }] : null}
											isMulti={false}
											placeholder="انتخاب گمرک"
											noOptionsMessage={({ inputValue }) =>
												inputValue ? "نتیجه‌ای یافت نشد" : null
											}
											defaultOptions={[]}
											components={{
												DropdownIndicator: () => null,
												IndicatorSeparator: () => null,
											}}
											loadOptions={(inputValue, callback) => this.loadPersonsOptions(inputValue, callback, 1)}
											onChange={e => this.setCalculatorCustom(e)}
										/>
									</div>
								</div>
								<div className="col-sm-1">
									<div className="form-group">
										<label for="invoiceDate" className="title1">تاریخ<span className="red">*</span></label>
										<DatePicker
											inputReadOnly={false}
											className="form-control input-sm persian-date"
											placeholder={"تاریخ"}
											isGregorian={false}
											showTodayButton={true}
											timePicker={false}
											onChange={(e) => { this.state.data.record.date = e }}
											value={this.getFormatedDateForDatePicker(this.state.data.record.date)}
										/>
									</div>
								</div>
								<div className="col-sm-1">
									<div className="form-group">
										<label className="title1">شماره</label>
										<input onChange={e => this.state.data.record.number = parseInt(e.target.value)} defaultValue={this.state.data.record.number} autocomplete="off" type="text" className="form-control input-smnumber" maxlength="20" />
									</div>
								</div>
								<div className="col-sm-1">
									<div className="form-group">
										<label className="title1">کشور مبدا</label>
										<input onChange={e => this.state.data.record.originPort = e.target.value} defaultValue={this.state.data.record.originPort} autocomplete="off" type="text" className="form-control input-smnumber" maxlength="150" />
									</div>
								</div>
								<div className="col-sm-12">
									<div className="form-group">
										<label className="title1">توضیحات</label>
										<input onChange={e => this.state.data.record.description = e.target.value} defaultValue={this.state.data.record.description} autocomplete="off" type="text" className="form-control input-smnumber" maxlength="400" />
									</div>
								</div>
							</div>

							<div className="row">
								<div className={"col-lg-12"}>
									<table className="table table-bordered acc_grid_row">
										<thead>
											<tr className="active">
												<td style={{ "width": "30px" }}>#</td>
												<td style={{ minWidth: "60px" }}>فاکتور</td>
												<td style={{ minWidth: "200px" }}>آیتم</td>
												<td style={{ "width": "70px" }}>
													<span>تعداد/مقدار</span>
												</td>
												<td>واحد اصلی</td>
												{this.state.data.global.company.stuffSubUnitEnable === 2 && <td style={{ "width": "70px" }}>
													<span>تعداد/مقدار<br />فرعی</span>
												</td>}
												{this.state.data.global.company.stuffSubUnitEnable === 2 && <td>واحد فرعی</td>}
												<td style={{ minWidth: "100px" }}>قیمت کل</td>
												<td style={{ minWidth: "100px" }}>هزینه گمرک</td>
												<td style={{ minWidth: "100px" }}>مالیات</td>
												<td style={{ minWidth: "100px" }}>عوارض</td>
												<td style={{ "width": "35px" }}></td>
											</tr>
										</thead>
										{this.renderBody()}
									</table>
								</div>
							</div>

							<div className="row">
								<div className="col-sm-2">
									<label className="form-group">هزینه گمرک</label>
									<NumberFormat value={this.state.data.record.totalCustomsCost} disabled={true} thousandSeparator={true} prefix={''} className='form-control text-center ltr' style={{ backgroundColor: "mintcream" }} />
								</div>
								<div className="col-sm-2">
									<label className="form-group">مالیات</label>
									<NumberFormat value={this.state.data.record.totalTax} disabled={true} thousandSeparator={true} prefix={''} className='form-control text-center ltr' style={{ backgroundColor: "mintcream" }} />
								</div>
								<div className="col-sm-2">
									<label className="form-group">عوارض</label>
									<NumberFormat value={this.state.data.record.totalToll} disabled={true} thousandSeparator={true} prefix={''} className='form-control text-center ltr' style={{ backgroundColor: "mintcream" }} />
								</div>
								<div className="col-sm-2">
									<label className="form-group">مبلغ کل</label>
									<NumberFormat value={this.state.data.record.totalCost} disabled={true} thousandSeparator={true} prefix={''} className='form-control text-center ltr' style={{ backgroundColor: "mintcream" }} />
								</div>
							</div>
						</div>
						<div className="modal-footer">
							<button type="button" className="hand btn btn-primary" onClick={e => this.save(e)} >ذخیره</button>
							&nbsp;
							{this.state.data.record.id !== this.defaultGuid() && <a className="btn btn-danger me-2" onClick={e => this.confirmRemove(this.state.data.record.id, !this.fromOrdering())} >حذف فاکتور</a>}
							<a className="btn btn-warning" onClick={e => this.closeMe()}>انصراف</a>
						</div>
					</div>
				</div>
			</div>
		</div>
	}
	render() {
		if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />

		let contents = this.state.loading ? this.renderLoading() :
			[
				this.state.lockScreen === 1 && this.lockScreen(),
				this.getGlobalContainer(),
				this.state.data.status === 0 ? this.apiFailInModal() : this.renderForm(),
				this.renderPopupComponent()
			];

		return contents;
	}
}